/**
 * Auth storage utilities.
 * Handles persistence of auth-related data like remembered emails.
 */
const DEFAULT_REMEMBER_EMAIL_KEY = 'platform-auth:remember-email';
const POST_LOGIN_PATH_KEY = 'platform-auth:post-login-path';
/**
 * Get the storage key for remembered email.
 */
function getRememberEmailKey(options) {
    return options?.keyPrefix ? `${options.keyPrefix}:remember-email` : DEFAULT_REMEMBER_EMAIL_KEY;
}
/**
 * Get remembered email from storage.
 */
export function getRememberedEmail(options) {
    const key = getRememberEmailKey(options);
    return localStorage.getItem(key) ?? '';
}
/**
 * Save remembered email to storage.
 */
export function setRememberedEmail(email, options) {
    const key = getRememberEmailKey(options);
    localStorage.setItem(key, email);
}
/**
 * Clear remembered email from storage.
 */
export function clearRememberedEmail(options) {
    const key = getRememberEmailKey(options);
    localStorage.removeItem(key);
}
/**
 * Check if there is a remembered email.
 */
export function hasRememberedEmail(options) {
    return Boolean(getRememberedEmail(options));
}
/**
 * Save the post-login redirect path.
 */
export function setPostLoginPath(path) {
    sessionStorage.setItem(POST_LOGIN_PATH_KEY, path);
}
/**
 * Get and clear the post-login redirect path.
 */
export function consumePostLoginPath(defaultPath = '/') {
    const path = sessionStorage.getItem(POST_LOGIN_PATH_KEY) ?? defaultPath;
    sessionStorage.removeItem(POST_LOGIN_PATH_KEY);
    return path;
}
//# sourceMappingURL=storage.js.map